<template>
  <EditorPickLotteryPickerSection data-containerid="pick_lottery_wager">
    <template #headline>{{ $t('picklottery.stake.title') }}</template>

    <LcFormField v-slot="{ field }" name="stake">
      <LcSlider
        v-bind="{ ...field, max, min, marker }"
        :value="selectedStake"
        class="w-full"
        container-class="w-full"
        :format="toStakeMoney"
        :lazy="false"
        no-feedback
        @update:value="handleSetStake"
      />
    </LcFormField>
  </EditorPickLotteryPickerSection>
</template>

<script lang="ts" setup>
import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import type { Config, PriceList } from '../@types/editor'
import type { EditorPlay } from '../stores/pickLottery'

type Props = {
  config: Config
  lotteryId: LotteryId
  play: EditorPlay
  priceList: PriceList
}

const { config, lotteryId, play, priceList } = defineProps<Props>()

const { handleSetStake, marker, max, min, selectedStake } = usePickLotteryWager(
  lotteryId,
  () => config,
  () => priceList,
  () => play,
)
</script>
